import { uniq, map } from 'lodash-es'
import { treq } from '#app/lib/treq'
import { getNonEmptyPropertyClaims } from '#entities/components/editor/lib/editors_helpers'
import type { SerializedEntity } from '#entities/lib/entities'
import type { EntityUri } from '#server/types/entity'

export default async function ({ entity }: { entity: SerializedEntity }) {
  const publishersUris = getNonEmptyPropertyClaims(entity.claims['wdt:P123'])

  if (!publishersUris) return

  const collectionsUris = await Promise.all(publishersUris.map(getPublisherCollections))
  return uniq(collectionsUris.flat())
}

async function getPublisherCollections (publisherUri: EntityUri) {
  const { collections } = await treq('entities', 'get', 'publisher-publications', { uri: publisherUri })
  return map(collections, 'uri')
}
